import api from 'Api'
import { SET_MESSAGE } from '../components/utils'
const moment = require('moment')
const URL = '/analytics/data-risk-detail-analysis'
const URL_OVERVIEW_RISK = '/analytics/container'

const state = {
  // Filters
  level: 'container_name',
  dataStructureType: 'both',
  sensitivityThreshold: 50,
  keyWordFilter: '',
  // Data
  catalogData: [],
  containerData: [],
  catalogDataLoading: true,
  containerDataLoading: false
}

const getters = {
  getCollectionNames: state => {
    const collections = state.catalogData && state.catalogData.map(item => item.container_name)
    return collections && collections.filter((a, b) => collections.indexOf(a) === b)
  },
  getCatalogLevelData: (state, getters) => {
    const data = state.catalogData
    if (state.level === 'container_name') {
      const items = []
      for (let i = 0; i < data.length; i++) {
        const children = data && data.filter(item => item.container_id === data[i].collection_id)
        const totalVolumeSum = children.reduce((total, item) => Number(total) + Number(item.total_volume), 0)
        const containerId = data[i].container_id
        const collectionId = data[i].collection_id
        let iterationItems

        if (children.length > 0) {
          iterationItems = {
            name: data[i].container_name,
            children: children,
            collection_ct: data[i].collection_ct,
            container_ct: data[i].container_ct,
            totalVolumeSum,
            data_risk_aggregation: data[i].data_risk_aggregation,
            containerId,
            collectionId,
            collector_id: data[i].collector_id,
            containerName: data[i].container_name
          }
        } else {
          iterationItems = {
            name: data[i].container_name,
            children: [],
            collection_ct: data[i].collection_ct,
            container_ct: data[i].container_ct,
            totalVolumeSum: data[i].total_volume,
            data_risk_aggregation: data[i].data_risk_aggregation,
            containerId: data[i].container_id,
            collectionId: data[i].collection_id,
            collector_id: data[i].collector_id,
            containerName: data[i].container_name
          }
        }
        items.push(iterationItems)
      }
      return items
    } else if (state.level === 'collection_name') {
      const items = []
      const itemNames = getters.getCollectionNames
      for (let i = 0; i < itemNames.length; i++) {
        const iterationItems = {
          name: itemNames[i],
          size: state.catalogData[i].size,
          containerId: state.catalogData[i].container_id,
          collectionId: state.catalogData[i].collection_id,
          data_risk_aggregation: state.catalogData[i].data_risk_aggregation,
          item: { ...state.catalogData[i] },
          collection_ct: state.catalogData[i].collection_ct,
          children: [],
          container_ct: data[i].container_ct,
          collector_id: data[i].collector_id,
          containerName: state.catalogData[i].container_name
        }

        items.push(iterationItems)
      }
      return items
    }
  },
  getFilteredCatalogLevelData: (state, getters) => {
    return getters.getCatalogLevelData && getters.getCatalogLevelData.filter(item => {
      return item?.name?.toLocaleLowerCase().indexOf(state.keyWordFilter?.toLocaleLowerCase()) !== -1
    })
  },
  getLevel: state => {
    return state.level
  },
  getCatalogData: state => {
    return state.catalogData && state.catalogData
  },
  getContainerData: state => {
    return state.containerData && state.containerData
  }
}

const actions = {
  async loadContainerData (context, payload) {
    context.commit('SET_CONTAINER_DATA_LOADING', true)
    const organizationId = payload?.organization_id ? payload.organization_id : context.rootState.currentOrganization.entity_id
    const containerId = payload.container_id
    if (!organizationId) {
      context.commit('SET_CONTAINER_DATA', [])
      return
    }
    let currentTime
    if (payload?.date) {
      currentTime = payload.date
    } else {
      const moments = context.rootState.dashboardServices.riskEnterpriseData?.date?.map(d => { return moment(d, 'YYYY-MM-DD') })
      currentTime = moments && moment(moment.max(moments)._i, 'YYYY-MM-DD').format('MM/YYYY')
    }
    let response
    try {
      let dsts = []
      if (payload.dst === 'both') {
        dsts = ['S', 'US']
      } else dsts = [payload.dst]

      let requests
      if (currentTime) {
        const month = currentTime?.split('/')[0].toString()
        const year = currentTime?.split('/')[1].toString()
        requests = dsts && dsts.map(dst => api().get(`${URL_OVERVIEW_RISK}?organization_id=${organizationId}&container_id=${containerId}&month=${month}&year=${year}&data_structure_type=${dst}`))
      } else {
        currentTime = moment().format('MM/YYYY')
        const month = currentTime?.split('/')[0].toString()
        const year = currentTime?.split('/')[1].toString()
        requests = dsts && dsts.map(dst => api().get(`${URL_OVERVIEW_RISK}?organization_id=${organizationId}&container_id=${containerId}&month=${month}&year=${year}&data_structure_type=${dst}`))
      }

      response = await Promise.all(requests).then(responses => {
        // Reset Old Data
        context.commit('RESET_CONTAINER_DATA')
        // Add new data
        responses.forEach(res => context.commit('SET_CONTAINER_DATA', res.data))
      })
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
      context.commit('SET_CONTAINER_DATA_LOADING', false)
      // Reset Old Data
      context.commit('RESET_CONTAINER_DATA')
      return
    }
    context.commit('SET_CONTAINER_DATA_LOADING', false)
    return response
  },

  async loadCatalogData (context, payload) {
    context.commit('SET_CATALOG_DATA_LOADING', true)
    const organizationId = payload?.organization_id ? payload.organization_id : context.rootState.currentOrganization.entity_id

    if (!organizationId) {
      context.commit('SET_CATALOG_DATA', [])
      return
    }
    let currentTime
    if (payload?.date) {
      currentTime = payload.date
    } else {
      const moments = context.rootState.dashboardServices.riskEnterpriseData?.date?.map(d => moment(d, 'YYYY-MM-DD'))
      currentTime = moments && moment(moment.max(moments)._i, 'YYYY-MM-DD').format('MM/YYYY')
    }
    let response
    try {
      let dsts = []
      if (payload.dst === 'both') {
        dsts = ['S', 'US']
      } else dsts = [payload.dst]

      let requests
      if (currentTime) {
        requests = dsts && dsts.map(dst => api().get(`${URL}?organization_id=${organizationId}&month=${currentTime}&dst=${dst}`))
      } else {
        currentTime = moment().format('MM/YYYY')
        requests = dsts && dsts.map(dst => api().get(`${URL}?organization_id=${organizationId}&month=${currentTime}&dst=${dst}`))
      }

      response = await Promise.all(requests).then(responses => {
        // Reset Old Data
        context.commit('RESET_CATALOG_DATA')
        // Add new data

        responses.forEach(res => context.commit('SET_CATALOG_DATA', res.data))
      })
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
      context.commit('SET_CATALOG_DATA_LOADING', false)
      // Reset Old Data
      context.commit('RESET_CATALOG_DATA')
      return
    }
    context.commit('SET_CATALOG_DATA_LOADING', false)
    return response
  }
}

const mutations = {
  SET_LEVEL (state, level) {
    state.level = level
  },
  SET_DATA_STRUCTURE_TYPE (state, dataStructureType) {
    state.dataStructureType = dataStructureType
  },
  SET_SENSITIVITY_THRESHOLD (state, sensitivityThreshold) {
    state.sensitivityThreshold = sensitivityThreshold
  },
  SET_KEYWORD (state, keyWordFilter) {
    state.keyWordFilter = keyWordFilter
  },
  SET_CATALOG_DATA_LOADING (state, loading) {
    state.catalogDataLoading = loading
  },
  SET_CONTAINER_DATA_LOADING (state, loading) {
    state.containerDataLoading = loading
  },
  SET_CATALOG_DATA (state, data) {
    state.catalogData.push(...data)
  },
  SET_CONTAINER_DATA (state, data) {
    state.containerData.push(...data)
  },
  RESET_CATALOG_DATA (state, data) {
    state.catalogData = []
  },
  RESET_CONTAINER_DATA (state, data) {
    state.containerData = []
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  name: 'catalogServices'
}
